export default __webpack_public_path__ + "static/go-platinum-cashback-93ae1aef6dd298cd4cf025bab7ae2131.webp";